import React, { useState } from "react";
import ReuseModal from "../../../../../components/fragment/modal/ReuseModal";
import { RazorInputField, toast } from "../../../../../components/razor-reuse";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../../../redux/type";
import { updateUserPassword } from "../../../../../redux/settings";

interface myComponentProps {
  onClose?: () => void;
  onFinish?: () => void;
  visible?: boolean;
}

const ChangePasswordModal = ({
  onClose,
  onFinish,
  visible,
}: myComponentProps) => {
  type detailProps = {
    old_password: string;
    password: string;
    password_confirmation: string;
  };

  type errorProp = {
    old_password: boolean;
    password: boolean;
    password_confirmation: boolean;
  };

  const [error, setError] = useState<errorProp>({
    old_password: false,
    password: false,
    password_confirmation: false,
  });

  const dispatch = useDispatch();
  const { loadingDelete } = useSelector((state: RootState) => state.settings);
  const [details, setDetails] = useState<detailProps>({
    old_password: "",
    password: "",
    password_confirmation: "",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const obj = { ...details, [name]: value };
    const objError = { ...error, [name]: false };
    setError(objError);
    setDetails(obj);
  };

  const handleSubmit = async (e?: any) => {
    e && e.preventDefault();
    if (details?.password !== details?.password_confirmation) {
      toast.error("Passwords does not match!!!");
      setError((prev) => {
        return { ...prev, password: true, password_confirmation: true };
      });
      return;
    }
    const data = await dispatch(updateUserPassword(details) as any);

    if (data?.payload?.data?.status) {
      setDetails({
        old_password: "",
        password: "",
        password_confirmation: "",
      });
      onClose && onClose();
    }
  };

  return (
    <>
      <ReuseModal
        title="Change Password"
        btnLabel="Update Password"
        visible={visible}
        onClose={onClose}
        disable={
          !details?.old_password ||
          !details?.password ||
          !details?.password_confirmation
        }
        loading={loadingDelete}
        onBtnClick={handleSubmit}
      >
        <form
          style={{ width: "100%" }}
          onSubmit={(e) => {
            e.preventDefault();
          }}
          action=""
          autoComplete="off"
        >
          <RazorInputField
            color="black-light"
            type="password"
            label="Current Password"
            placeholder="Enter Password"
            value={details?.old_password}
            name="old_password"
            onChange={handleChange}
          />
        </form>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          style={{ width: "100%" }}
          action=""
          autoComplete="off"
        >
          <RazorInputField
            color="black-light"
            type="password"
            label="New Password"
            placeholder="Enter Password"
            value={details?.password}
            name="password"
            onChange={handleChange}
            showError={error?.password}
          />
        </form>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          style={{ width: "100%" }}
          action=""
          autoComplete="off"
        >
          <RazorInputField
            color="black-light"
            type="password"
            label="Confirm Password"
            placeholder="Enter Password"
            value={details?.password_confirmation}
            name="password_confirmation"
            onChange={handleChange}
            showError={error?.password_confirmation}
          />
        </form>
      </ReuseModal>
    </>
  );
};

export default ChangePasswordModal;
